import { statusLabel } from "@/lib/labels";
/**
 * Holat nishoni.
 *
 * Holat nomlari serverdan keladi va ular ko'p: PENDING, IN_PROGRESS,
 * WAITING_MANAGER, SHORTAGE, DEAD… Ro'yxatni qo'lda yozish yangi
 * holat qo'shilganda uni "noma'lum" qilib qoldirardi, shuning uchun
 * rang NOM SHAKLIDAN aniqlanadi va tanilmagan holat neytral
 * ko'rinadi — yo'qolib qolmaydi.
 */
/**
 * `tag` — holat EMAS, toifa (rol, LP turi, obyekt turi, qoida
 * kodi). Monoxrom: chegara bilan, nuqtasiz. Rang faqat holat uchun
 * qoladi — aks holda ko'k toifa yorliqlari «jarayonda» holati bilan
 * aralashib ketardi.
 */
type Tone = "success" | "warning" | "error" | "info" | "neutral" | "tag";

const EXPLICIT: Record<string, Tone> = {
  COMPLETED: "success",
  APPROVED: "success",
  ACTIVE: "success",
  READY: "success",
  SENT: "success",
  CLEAN: "success",
  DECIDED: "success",
  RESOLVED: "success",
  HANDED_OFF: "success",
  DELIVERED: "success",
  APPLIED: "success",

  IN_PROGRESS: "info",
  ASSIGNED: "info",
  STAGING: "info",
  COUNTING: "info",
  RETURNING: "info",
  ARRIVED: "info",
  RECEIVING: "info",
  ALLOCATED: "info",
  PICKED: "info",
  DRAFT: "neutral",
  PENDING: "neutral",
  CREATED: "neutral",

  WAITING_MANAGER: "warning",
  WAITING_INVENTORY: "warning",
  SHORTAGE: "warning",
  EXCESS: "warning",
  PARTIAL: "warning",
  // "INCOMPLETE" ichida "COMPLET" bor — aniq yozilmasa quyidagi
  // taxmin uni yashil (muvaffaqiyat) qilib qo'yardi (FIX-05 signali).
  INCOMPLETE: "warning",

  MANUAL_REVIEW: "warning",
  MISSING_IN_1C: "warning",
  MISSING_IN_WMS: "warning",
  MATCH: "success",
  CONFIRMED: "success",
  MATCHED: "success",
  CONTROLLED: "success",
  EXPIRED: "warning",
  RECOUNT: "warning",

  FAILED: "error",
  DEAD: "error",
  DEAD_LETTER: "error",
  REJECTED: "error",
  INFECTED: "error",
  CANCELLED: "error",
  BLOCKED: "error",
  // Nomida kalit so'z yo'q: taxmin ularni neytral qoldirardi va
  // tafovut ko'zga tashlanmasdi.
  MISMATCH: "error",
  SOURCE_MISMATCH: "error",
  LOCATION_MISMATCH: "error",
  LP_MISMATCH: "error",
  NOT_FOUND: "error",
};

function toneOf(value: string): Tone {
  const upper = value.toUpperCase();
  const explicit = EXPLICIT[upper];
  if (explicit) return explicit;

  // Tanilmagan holat: nom shaklidan taxmin qilinadi.
  if (upper.startsWith("WAITING")) return "warning";
  if (upper.includes("FAIL") || upper.includes("ERROR")) return "error";
  if (upper.includes("CANCEL") || upper.includes("REJECT")) return "error";
  if (upper.includes("COMPLET") || upper.includes("DONE")) return "success";
  return "neutral";
}

export function StatusBadge({
  value,
  tone,
  label: given,
}: {
  value: string;
  tone?: Tone;
  /** Tayyor nom (masalan rol) — holat lug'ati o'rniga ishlatiladi. */
  label?: string;
}) {
  if (!value || value === "—") return <span style={{ color: "var(--outline)" }}>—</span>;

  const resolved = tone ?? toneOf(value);
  const className =
    resolved === "neutral"
      ? "badge badge-dot"
      : resolved === "tag"
        ? "badge badge-tag"
        : `badge badge-${resolved} badge-dot`;

  // Kodning o'zi `title` da qoladi: xizmat bilan gaplashganda xodim
  // `INCOMPLETE` deb ayta olishi kerak.
  const label = given ?? statusLabel(value);
  return (
    <span className={className} title={label === value ? undefined : value}>
      {label}
    </span>
  );
}
